<template>
  <section class>
    <ul class="tabs">
      <li
        class="tab"
        v-for="(item, index) in tabs"
        :key="item.type"
        :class="{ 'tab--active': activeTab === index }"
        @click="changeTab(index)"
      >{{ item.name }}</li>
    </ul>
    <div class="wrapper">
      <ul class="author-list">
        <li
          v-for="(item, index) in authorList"
          :key="index"
          class="author-wrapper"
        >
          <div class="author">
            <router-link class="author-inline" :to="`/author/${item.authorId}`">
              <div class="author-head">
                <router-link
                  class="head"
                  :style="{ backgroundImage: `url(${item.headPic})` }"
                  :to="`/author/${item.authorId}`"
                >
                  <div class="vicon"></div>
                </router-link>
                <div class="author-head-right">
                  <router-link
                    class="author-name"
                    :to="`/author/${item.authorId}`"
                  >{{ item.name }}</router-link>
                  <div class="author-type-company">
                    <span
                      class="author-type"
                      :class="{'reset-author-type':!item.authorCompany}"
                    >{{ item.typeName }}</span>
                    {{
                    item.authorCompany.length > 4
                    ? item.authorCompany.substring(0, 4) + '...'
                    : item.authorCompany
                    }}
                  </div>
                  <div class="author-follower">粉丝数:{{ item.followerNum }}</div>
                </div>
              </div>
              <div class="author-middle">
                {{
                item.remark.length > 70
                ? item.remark.substring(0, 70) + '...'
                : item.remark
                }}
              </div>
              <div class="author-tags">
                <el-tag
                  v-for="(item, index) in item.tagSkill.length > 1
                    ? item.tagSkill.slice(0, 2)
                    : item.tagSkill"
                  :key="index"
                  class="author-tag-li"
                >{{ item }}</el-tag>
              </div>
            </router-link>
          </div>
        </li>
        <li v-show="!pageEnd" class="more" @click="getAuthorList">点击查看更多</li>
      </ul>
    </div>
  </section>
</template>

<script>
import { getAuthorList } from '@/api/author'

export default {
  name: 'Author',
  data() {
    return {
      tabs: [
        { name: '人气', type: 2 },
        { name: '收益高', type: 3 },
        { name: '特约嘉宾', type: 4 },
        { name: '新锐', type: 5 }
      ],
      activeTab: 0,
      authorList: [],
      viewState: '',
      pageEnd: false
    }
  },
  created() {
    this.getAuthorList()
  },
  methods: {
    changeTab(index) {
      this.activeTab = index
      this.viewState = ''

      this.getAuthorList()
    },
    async getAuthorList() {
      const data = await getAuthorList(
        {
          type: this.tabs[this.activeTab].type,
          direction: this.viewState ? 2 : 0,
          pageSize: 12
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end

          if (data.detail.flush) {
            this.authorList = data.detail.list
          } else {
            this.authorList = this.authorList.concat(data.detail.list)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.author-type:after {
  content: '';
  height: 12px;
  margin-left: 2px;
  width: 1px;
  background-color: #858585;
  display: inline-block;
  vertical-align: middle;
}
.reset-author-type:after {
  background: none;
}

.tabs {
  margin-top: 30px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #262626;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  margin-right: 15px;

  .tab {
    width: 98px;
    cursor: pointer;
  }

  .tab--active {
    position: relative;
    color: #046bcc;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 34px;
      height: 4px;
      background-color: #046bcc;
    }
  }
}

.caret-wrapper {
  display: inline-flex;
  height: 34px;
  width: 24px;
  overflow: initial;
  position: relative;
}

.author-list {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  margin-bottom: 30px;
}
.author-wrapper {
  width: 25%;
}
.author {
  height: 300px;
  width: 280px;
  margin-top: 30px;
  align-content: flex-start;
  border: solid 1px #ebebeb;
}

// .author-wrapper:nth-child(4n) > .author {
//  text-align: right;
// }

.author-inline {
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
}

.head {
  width: 60px;
  height: 60px;
  background: no-repeat center;
  background-size: cover;
  border-radius: 50%;
  cursor: pointer;
}
.author-head {
  display: flex;
  position: relative;
  flex-direction: row;
}

.author-head-right {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.author-name {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #262626;
  text-decoration: none;
}
.author-type-company {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  margin-top: 8px;
  letter-spacing: 1px;
  color: #858585;
}

.author-follower {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  margin-top: 6px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #858585;
}

.author-tags {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  height: 60px;
}

.author-tag-li {
  display: inline-block;
  margin-right: 14px;
  font-size: 14px;
  border: none;
  color: #046bcc;
}

.author-middle {
  margin-top: 25px;
  height: 112px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 1px;
  color: #262626;
}

.wrapper {
  display: flex;
}

.vicon {
  top: 39px;
  left: 39px;
  position: absolute;
  width: 20px;
  height: 20px;
  background: url('~@/assets/images/author/vicon.png') no-repeat center;
  background-size: contain;
  border-radius: 50%;
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
</style>
